export default function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}


//////////////////
// WEBPACK FOOTER
// /data/websites/opacivibank.it/httpdocs/wp-content/themes/g2k-theme/node_modules/@popperjs/core/lib/utils/uniqueBy.js
// module id = 61
// module chunks = 0